import { render } from "./TeoConnect.vue?vue&type=template&id=f37face6&scoped=true"
import script from "./TeoConnect.vue?vue&type=script&lang=js"
export * from "./TeoConnect.vue?vue&type=script&lang=js"

import "./TeoConnect.vue?vue&type=style&index=0&id=f37face6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37face6"]])

export default __exports__